import { useState } from "react";
import isEmpty from 'lodash/isEmpty'

import DataGrid from "../components/DataGrid";
import OwnerEdit from "./OwnerEdit";

import currencyFormatter from "../utils/currencyFormatter";

const columns = [
    // {
    //     field: 'OwnerID',
    //     headerName: 'OwnerID',
    //     type: 'number',
    //     valueGetter: ({row}) => row.id,
    //     filterable: false,
    //     width: 100,
    // },
    {
        field: 'Name',
        headerName: 'Name',
        type: 'string',
        valueGetter: ({row}) => row.name,
        width: 300,
        renderCell: (params) => {
            const filter = {items:[{field:"Name",operator:"contains",value:params.value}],logicOperator:"and",quickFilterLogicOperator:"and"}
            return (
                <a href={"https://leasemax.app/leases?filters=" + encodeURIComponent(JSON.stringify(filter))} target="_blank">{params.value}</a>
            )
        }
    },
    {
        field: 'Address',
        headerName: 'Address',
        type: 'string',
        valueGetter: ({row}) => row.address,
        width: 400,
    },
    {
        field: 'City',
        headerName: 'City',
        type: 'string',
        valueGetter: ({row}) => row.city,
        filterable: false,
        width: 150,
    },
    {
        field: 'State',
        headerName: 'State',
        type: 'string',
        valueGetter: ({row}) => row.state,
        filterable: false,
        width: 100,
    },
    {
        field: 'Zip',
        headerName: 'Zip',
        type: 'string',
        valueGetter: ({row}) => row.zip,
        filterable: false,
        width: 100,
    },
    {
        field: 'NetWorth',
        headerName: 'Net Worth',
        type: 'number',
        valueGetter: ({row}) => row.networth * 1,
        valueFormatter: currencyFormatter,
        width: 100,
    },
    {
        field: 'PhoneNumber',
        headerName: 'PhoneNumber',
        type: 'string',
        valueGetter: ({row}) => row.phonenumber,
        filterable: false,
        width: 150,
    },
    {
        field: 'Comments',
        headerName: 'Comments',
        type: 'string',
        valueGetter: ({row}) => row.comments,
        filterable: false,
        flex: 1,
    },
  ];

function Owners() {
    const [activeId, setActiveId] = useState();
    const [activityType, setActivityType] = useState('none');
    const [selectedIds, setSelectedIds] = useState([]);
    return (
        <>
            <DataGrid 
                columns={columns} 
                baseURL='/api/owners?wksp=false' 
                searchCriteria={null} 
                searchKey={null}
                activeId={activeId}
                onRowDoubleClick={({row})=>{
                    setActivityType('edit');
                    setActiveId(row.id);
                    setSelectedIds([]);
                }}                
                onMerge={(rowSelectionModel)=>{
                    if(isEmpty(rowSelectionModel))
                        return;
                    setActivityType('merge');
                    setActiveId(rowSelectionModel[0]);
                    setSelectedIds(rowSelectionModel);
                }} 
            />
            <OwnerEdit  
                activeId={activeId} 
                activityType={activityType}
                selectedIds={selectedIds}
                onClose={()=>{
                    setActivityType(null);
                    setActiveId(null);
                    setSelectedIds([]);
                }}
            />
        </>
    );
}

export default Owners;